import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import ProjectNav from "@/components/feature/ProjectNav";
import FrameOverlay from "@/components/base/FrameOverlay";
import FadeIn from "@/components/base/FadeIn";
import TiltCard from "@/components/base/TiltCard";
import { artistPortfolioImages } from "@/mocks/portfolio";
import { Link } from "react-router-dom";

export default function SeraphinaDorPage() {
  const works = artistPortfolioImages["seraphina-dor"];

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <section className="bg-background-50 pt-32 md:pt-40 pb-24 md:pb-36">
          <div className="px-6 md:px-12">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
              <div>
                <p className="font-display text-xs uppercase tracking-[0.25em] text-foreground-700 mb-4 title-eyebrow">
                  ( Master Artist ) — Fine Line & Gold Accent
                </p>
                <h1 className="font-display font-black text-foreground-950 leading-[0.9] tracking-[-0.04em] text-[14vw] md:text-[10vw] lg:text-[9vw] whitespace-nowrap">
                  <span className="title-caps">Seraphina</span>
                  <em className="font-serif italic font-light title-italic"> Dor</em>
                </h1>
              </div>
              <div className="max-w-md">
                <p className="text-base md:text-lg text-foreground-700 leading-relaxed font-serif">
                  Trained in the illumination arts of Paris, Seraphina creates tattoos that read like precious manuscripts on skin — delicate, luminous, and unmistakably sacred. Her signature fine-line technique, accented with antique gold pigments, creates pieces that appear to float.
                </p>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-3 mb-12" data-product-shop>
              {["Fine Line", "Ethereal", "Gold Accent", "11 yrs"].map((tag, i) => (
                <span key={i} className="px-4 py-2 rounded-full border border-foreground-950/30 text-foreground-950 text-xs uppercase tracking-[0.18em] font-display">
                  {tag}
                </span>
              ))}
            </div>

            <div className="mb-16 md:mb-20 max-w-3xl">
              <p className="font-serif italic text-2xl md:text-3xl text-accent-700 leading-relaxed">
                &ldquo;Delicacy is not fragility — it is precision distilled.&rdquo;
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-product-shop>
              {works.map((w, i) => (
                <FadeIn key={i} delay={i * 60} className="group cursor-pointer">
                  <TiltCard className="mb-3">
                    <div className={`img-hover ${w.aspect} bg-background-100 overflow-hidden relative`}>
                      <img src={w.image} alt={w.id} className="w-full h-full object-cover object-top" />
                      <FrameOverlay />
                    </div>
                  </TiltCard>
                  <div className="flex items-center justify-between">
                    <span className="font-display text-[11px] md:text-xs uppercase tracking-[0.2em] text-foreground-950">{w.id}</span>
                    <i className="ri-arrow-right-up-line text-foreground-950 text-base opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  </div>
                </FadeIn>
              ))}
            </div>

            <div className="mt-20 pt-12 border-t border-foreground-950/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
              <div>
                <p className="font-display text-sm uppercase tracking-[0.15em] text-foreground-950 mb-2">Begin Your Commission</p>
                <p className="text-foreground-700 font-serif text-sm">Current waitlist: 8–12 months.</p>
              </div>
              <Link
                to="/"
                state={{ faScrollTo: "booking" }}
                className="inline-flex items-center gap-3 px-8 py-4 bg-primary-500 text-background-50 font-display text-xs uppercase tracking-[0.2em] rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Join Waitlist
                <i className="ri-arrow-right-up-line"></i>
              </Link>
            </div>
          </div>
        </section>

        <ProjectNav
          prev={{ label: "Cassius Vel", to: "/artist/cassius-vel" }}
          next={{ label: "Home", to: "/" }}
        />
      </main>
      <Footer />
    </div>
  );
}